import Cookies from 'js-cookie';

const removeShield = () => {
  const shield = document.querySelector('#b24-app-mode-shield');
  if (shield) {
    shield.remove();
  }
};

const addShield = () => {
  const shield = document.querySelector('#b24-app-mode-shield');
  if (shield) return true;

  const div = document.createElement('div');
  div.setAttribute('id', 'b24-app-mode-shield');

  div.innerHTML = `
    <a href="/prod" style="text-decoration: none; color: #ffffff; display: flex; align-items: center; justify-content: center; padding: 12px 20px 12px 16px;">
      <svg style="fill: #ffffff; margin-right: 8px;" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.293 13.707A1 1 0 0013 13V5a1 1 0 00-2 0v8a1 1 0 00.293.707zM7.27 19.446A8 8 0 0012 21a8 8 0 004.57-14.56 1 1 0 00-1.14 1.64 6 6 0 11-6.86 0 1 1 0 10-1.14-1.64 8 8 0 00-.16 13.006z"/></svg>
      <span style="max-width: 145px;">Выключить <b>режим предпросмотра</b></span>
    </a>
    <button type="button" id="b24-close-app-mode-shield" style="border:none; border-left: 1px solid #f05557; padding: 12px; display: flex; align-items: center; justify-content: center; background-color: transparent; cursor: pointer;">
      <svg style="fill: #ffffff;" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M4.433 19.617c.487.489 1.28.491 1.767.002l5.277-5.295 5.277 5.31c.487.49 1.278.487 1.765-.002.487-.49.489-1.286.002-1.776l-5.275-5.307 5.39-5.408a1.258 1.258 0 00-.003-1.773 1.247 1.247 0 00-1.766-.003l-5.388 5.406-5.348-5.38a1.244 1.244 0 00-1.765.002 1.262 1.262 0 00-.002 1.775l5.346 5.379-5.28 5.297a1.258 1.258 0 00.003 1.773z"/></svg>
    </button>
  `;
  div.style.position = 'fixed';
  div.style.bottom = '16px';
  div.style.right = '16px';
  div.style.backgroundColor = '#f46363';
  div.style.borderRadius = '4px';
  div.style.zIndex = '999';
  div.style.display = 'flex';
  div.style.fontSize = '14px';
  document.body.append(div);

  const buttonClose = document.querySelector('#b24-close-app-mode-shield');
  buttonClose.addEventListener('click', (event) => {
    event.preventDefault();
    removeShield();
  });
};

const init = () => {
  const appModeCookie = Cookies.get('TEYmIicR5ey6OclmOSOZQHYGzTi');
  if (appModeCookie === 'HOKt5iCHlRwLf7lcvvG7YP2LsA57ZuhJnazlqAok2s01') {
    addShield();
  } else {
    removeShield();
  }
};

init();
